import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import LessonChip from './LessonChip';
import WorksheetChip from './WorksheetChip';
import styles from './DraftsPanel.module.css';

function DraftsPanel({ drafts, loading, onClose, onLessonClick }) {
  const { setNodeRef, isOver } = useDroppable({
    id: 'drafts-panel',
    data: { type: 'drafts' },
  });

  const contentClass = [
    styles.content,
    isOver ? styles.dropTarget : '',
  ].filter(Boolean).join(' ');

  return (
    <>
      <div className={styles.overlay} onClick={onClose} />
      <div className={styles.panel}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
            Drafts
          </h2>
          <button className={styles.closeBtn} onClick={onClose} aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div ref={setNodeRef} className={contentClass}>
          {isOver && (
            <div className={styles.dropHint}>Drop to unschedule</div>
          )}

          {loading && (
            <div className={styles.loadingState}>
              <div className={styles.spinner} />
              <span>Loading drafts...</span>
            </div>
          )}

          {!loading && drafts.length === 0 && !isOver && (
            <div className={styles.emptyState}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="var(--gray-300)" strokeWidth="1.5">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
              <p>No drafts</p>
              <span>Unscheduled lessons and activities will appear here</span>
            </div>
          )}

          {!loading && drafts.map((draft) => (
            draft._itemType === 'worksheet' ? (
              <WorksheetChip
                key={`ws-${draft.id}`}
                worksheet={draft}
                source="drafts"
              />
            ) : (
              <LessonChip
                key={`ls-${draft.id}`}
                lesson={draft}
                source="drafts"
                onClick={onLessonClick}
              />
            )
          ))}
        </div>
      </div>
    </>
  );
}

export default DraftsPanel;
